import React from 'react';
import styles from '../styles.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
import { getRtowText } from '@utils/utils';
import { formatLocaleDateDay } from '@utils/formatDisplay';
import { getSearchUrlParams } from '@utils/utils';

const SearchPlaceHolder = () => {
    const { SearchPrice, SaleInfo } = useSelector((state: RootState) => state.search);

    const hasFlightInfos = !(!SearchPrice.data?.FlightInfos || SearchPrice.data.FlightInfos?.length === 0)

    if (SearchPrice.isLoading || !hasFlightInfos || (SaleInfo && !hasFlightInfos)) {
        return <div>請開始搜尋...</div>;
    }

    const { Rtow, Adt, Chd, Inf, Depart1, Arrive1, ArrCity1, DepCity1 } = getSearchUrlParams();
    const data = !!SearchPrice.data.FlightInfos && SearchPrice.data.FlightInfos[0].ItineraryInfos;

    const RtowText = getRtowText(Rtow);
    const total = Adt + Chd + Inf;
    const depDate = formatLocaleDateDay(data[0]?.DepDateTime);
    const arrDate = data[1] ? `-${formatLocaleDateDay(data[1]?.DepDateTime)}` : '';
    const depCity = `${data[0]?.DepCityName}${DepCity1}`;
    const arrCity = `${data[0]?.ArrCityName}${ArrCity1}`;
    const depAirport = `${data[0]?.DepAirportName}${Depart1}`;
    const arrAirport = `${data[0]?.ArrAirportName}${Arrive1}`;

    // 手機板 顯示畫面跟 searchpanel 同步
    const searchDepText = Depart1 === "" ? depCity : depAirport;
    const searchArrDepText = Arrive1 === "" ? arrCity : arrAirport;



    return (
        <>
            <div className={styles.placeText}>
                <span>{`${searchDepText}-${searchArrDepText} `}</span>
                <span>{RtowText}</span>
            </div>
            <div className={styles.date}>{`${depDate}${arrDate}，共${total}人`}</div>
        </>
    );
};

export default SearchPlaceHolder;
